import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card__head d-flex align-items-center pr-4" }
const _hoisted_2 = { class: "d-flex align-items-center text-uppercase mb-0" }
const _hoisted_3 = { class: "bt-icon bt-icon--m" }
const _hoisted_4 = { class: "ml-2" }
const _hoisted_5 = { class: "d-flex align-items-center ml-auto" }
const _hoisted_6 = { class: "btn-stripped" }
const _hoisted_7 = { class: "btn-stripped text-danger" }
const _hoisted_8 = { class: "bt-icon bt-icon--xs" }
const _hoisted_9 = { class: "ml-2" }
const _hoisted_10 = {
  key: 0,
  class: "list-blocks"
}
const _hoisted_11 = { class: "room-object__head" }
const _hoisted_12 = { class: "room-object__icon bt-icon bt-icon--s" }
const _hoisted_13 = { style: {"text-transform":"capitalize"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_Button = _resolveComponent("Button")
  const _component_ElDropdownItem = _resolveComponent("ElDropdownItem")
  const _component_ElDropdownMenu = _resolveComponent("ElDropdownMenu")
  const _component_ElDropdown = _resolveComponent("ElDropdown")
  const _component_DeviceCarousel = _resolveComponent("DeviceCarousel")
  const _component_Card = _resolveComponent("Card")
  const _component_DialogConfirmDeleteAggregateCommand = _resolveComponent("DialogConfirmDeleteAggregateCommand")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Card, { class: "card--primary mb-3" }, {
      content: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("h4", _hoisted_2, [
            _createVNode("span", _hoisted_3, [
              _createVNode(_component_InlineSvgScoped, {
                src: 
                                require(`@/assets/images/icons/${_ctx.iconName}.svg`)
                            ,
                "aria-label": _ctx.iconName
              }, null, 8, ["src", "aria-label"])
            ]),
            _createVNode("span", _hoisted_4, _toDisplayString(_ctx.commandGroup.name), 1)
          ]),
          _createVNode("div", _hoisted_5, [
            (_ctx.isDefined)
              ? (_openBlock(), _createBlock(_component_ElDropdown, {
                  key: 0,
                  trigger: "click",
                  placement: "bottom-end",
                  "popper-class": "el-dropdown__popper el-dropdown--context"
                }, {
                  dropdown: _withCtx(() => [
                    _createVNode(_component_ElDropdownMenu, { style: {"width":"300px"} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ElDropdownItem, { onClick: _ctx.handleEdit }, {
                          default: _withCtx(() => [
                            _createVNode("button", _hoisted_6, _toDisplayString(_ctx.$t("AppResource.Edit")), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"]),
                        _createVNode(_component_ElDropdownItem, { onClick: _ctx.toggleDeleteAggregateCommandConfirm }, {
                          default: _withCtx(() => [
                            _createVNode("button", _hoisted_7, _toDisplayString(_ctx.$t("AppResource.Delete")), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _withDirectives(_createVNode(_component_Button, { class: "p-button p-button-text p-button-secondary py-0 ml-2" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_InlineSvgScoped, {
                          src: 
                                    require('@/assets/images/icons/icon-ellipsis-v.svg')
                                ,
                          "aria-label": "icon-ellipsis-v"
                        }, null, 8, ["src"])
                      ]),
                      _: 1
                    }, 512), [
                      [_vShow, !_ctx.disableActions]
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (!_ctx.isDefined && !_ctx.disableActions)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 1,
                  onClick: _ctx.handleAdd,
                  class: "p-button-outlined p-button-rounded bg-white"
                }, {
                  default: _withCtx(() => [
                    _createVNode("span", _hoisted_8, [
                      _createVNode(_component_InlineSvgScoped, {
                        src: 
                                    require(`@/assets/images/icons/icon-add-circle-outline.svg`)
                                ,
                        "aria-label": "icon-add"
                      }, null, 8, ["src"])
                    ]),
                    _createVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("AppResource.Add")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ])
        ]),
        (_ctx.isDefined && _ctx.commandGroup.devices)
          ? (_openBlock(), _createBlock("ul", _hoisted_10, [
              _createVNode("li", null, [
                _createVNode(_component_DeviceCarousel, {
                  itemsNumber: _ctx.commandGroup.devices.length
                }, {
                  carouselItems: _withCtx(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.commandGroup.devices, (device) => {
                      return (_openBlock(), _createBlock("div", {
                        key: device.id,
                        class: "room-object"
                      }, [
                        _createVNode("div", _hoisted_11, [
                          _createVNode("span", _hoisted_12, [
                            _createVNode(_component_InlineSvgScoped, {
                              src: 
                                                require(`@/assets/images/icons/icon-command.svg`)
                                            
                            }, null, 8, ["src"])
                          ]),
                          _createVNode("span", null, _toDisplayString(device.model) + " - ID " + _toDisplayString(device.id), 1)
                        ]),
                        _createVNode("span", _hoisted_13, _toDisplayString(_ctx.getConfiguredModulesText(device)), 1)
                      ]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["itemsNumber"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_DialogConfirmDeleteAggregateCommand, {
      "is-visible": _ctx.isVisibleDeleteAggregateCommandConfirm,
      onHideDialog: _ctx.toggleDeleteAggregateCommandConfirm,
      onConfirm: _ctx.handleDeleteAggregateCommand
    }, null, 8, ["is-visible", "onHideDialog", "onConfirm"])
  ], 64))
}